import React, { useState, useEffect } from "react";
import axios from "axios";
import SectionLandingLikePublications from "../common/SectionLandingLikePublications";

export default function FinancialEducation() {
  const [post, setPost] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get("/financialeducation")
      .then((response) => {
        const data = response.data;
        if (!cancelled) {
          setPost(Array.isArray(data) ? data : data ? [data] : []);
        }
      })
      .catch(() => {
        if (!cancelled) setPost([]);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const lead = (
    <>
      <p>
        The National Bank of Rwanda is a key player in Rwanda’s financial inclusion agenda. The bank works with
        other stakeholders to design and implement strategies and policies that advance financial inclusion.
      </p>
      <p>
        Rwanda considers financial inclusion integral to its development and poverty reduction objectives. Use
        the links below to explore programmes and resources in this section.
      </p>
    </>
  );

  return (
    <SectionLandingLikePublications
      breadcrumbCurrent="Financial Inclusion and Education"
      headingId="financial-education-bnr-heading"
      pageTitle="Financial Inclusion and Education"
      tagline="Strategies and resources for inclusive finance"
      sharePageTitle="Financial Inclusion and Education — National Bank of Rwanda"
      lead={lead}
      posts={post}
      pageFeedbackPath="/education"
      isLoading={isLoading}
    />
  );
}
